import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const doctorCabinet = {
  path: '/doctor-cabinet',
  component: Layout,
  name: 'doctorCabinet',
  redirect: '/doctor-cabinet/patients',
  children: [
    {
      path: '',
      name: 'CabinetLayout',
      component: () => import('@/views/doctorCabinet/layout'),
      children: [
        {
          path: '/doctor-cabinet/patients',
          component: () => import('@/views/doctorCabinet/patients'),
          name: 'doctor-cabinet.patients',
          meta: { title: i18n.t(`message.my_patients`) }
        },
        {
          path: '/doctor-cabinet/informal-patients',
          component: () => import('@/views/doctorCabinet/informal-patients'),
          name: 'doctor-cabinet.informal-patients',
          meta: { title: i18n.t(`message.status_doctor_free`) }
        },
        {
          path: '/doctor-cabinet/AllPatients',
          component: () => import('@/views/doctorCabinet/AllPatients'),
          name: 'doctor-cabinet.AllPatients',
          meta: { title: i18n.t(`message.my_conclusions`) }
        },
        {
          path: "/doctor-cabinet/outsource",
          component: () => import("@/views/doctorCabinet/outsource"),
          name: "doctor-cabinet.outsource",
          meta: { title: i18n.t(`message.outsource`) },
        },
        {
          path: "/doctor-cabinet/outsource-party",
          component: () => import("@/views/doctorCabinet/outsource-party"),
          name: "doctor-cabinet.outsource-party",
          meta: { title: i18n.t(`message.outsource_party`) },
        },

      ]
    }, {
      path: '/nurse-cabinet/orders',
      component: () => import('@/views/nurseCabinet/index'),
      name: 'nurse-cabinet.orders',
      meta: { title: i18n.t(`message.lab_nurse`) }
    },
    {
      path: '/doctor-cabinet/patientMedicine',
      component: () => import('@/views/patientMedicine/index'),
      name: 'doctor-cabinet.patientMedicine',
      meta: { title: i18n.t(`message.procedural`) }
    },
    {
      path: '/doctor-cabinet/patientMedicineShow',
      component: () => import('@/views/patientMedicineShow/index'),
      name: 'doctor-cabinet.patientMedicineShow',
      meta: { title: i18n.t(`message.procedural`) }
    },
    {
      path: '/doctor-cabinet/conclusions/:id',
      component: () => import('@/views/doctorCabinet/components/docCabPatientHistory'),
      name: 'patientConclusions',
      meta: { title: i18n.t(`message.patients`) }
    },
    {
      path: '/laboratory-cabinet/conclusions/:id',
      component: () => import('@/views/laboratoryCabinet/components/docCabPatientHistory'),
      name: 'patientLaboratoryConclusions',
      meta: { title: i18n.t(`message.patients`) }
    },
    // {
    //   path: '/doctor-cabinet/components/addDocument',
    //   component: () => import('@/views/doctorCabinet/components/addDocument'),
    //   name: 'addDocument',
    //   meta: { title: 'добавить документ'}
    // },
  ]
}

export default doctorCabinet